import { render, staticRenderFns } from "./SecondaryNavSectionModule.vue?vue&type=template&id=a8564832&"
import script from "./SecondaryNavSectionModule.vue?vue&type=script&lang=js&"
export * from "./SecondaryNavSectionModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports